import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { AUTH_ROUTES } from 'lib-klab-auth-ui';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    ...AUTH_ROUTES.map(r => ({
        ...r,
        canActivate: [noAuthGuard],
    })),
    {
        path: 'admin',
        canActivate: [authGuard, adminGuard],
        loadChildren: () => import('./modules/home/home.routes').then(m => m.HOME_ROUTES),
    },
    {
        path: '**',
        redirectTo: 'login'
    }
];
